import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'filter',
  initialState: {
    hasFilter: false,
    defaultFilter: {},
    filterData: {},
    filterTemp: {},
    savedFilter: {},
  },
  reducers: {
    setHasFilter: (state, action) => {
      state.hasFilter = action.payload;
    },
    setFilter: (state, action) => {
      state.filterData = action.payload;
    },
    setFilterTemp: (state, action) => {
      state.filterTemp = action.payload;
    },
    setSavedFilter: (state, action) => {
      state.savedFilter = action.payload;
    },
    resetFilter: (state, action) => {
      state.filterData = {};
      state.savedFilter = {};
      state.filterTemp = {};
      state.hasFilter = false;
      state.filterData = {};
    },
  },
});

export const {
  setHasFilter,
  setFilter,
  setFilterTemp,
  setSavedFilter,
  resetFilter,
} = slice.actions;
export default slice.reducer;
